import { Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import ModalLocation from "../../components/modal/ModalLocation";
import TableLocations from "../../components/table/TableLocations";

import { tr } from "../../i18n";
const TabLocations = () => {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(0);

  return (
    <>
      <Row className="mt-3">
        <Col lg={12} className="mb-4 d-flex gap-3 justify-content-end">
          <Button
            onClick={() => setShowModal(true)}
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm fw-small"
          >
            <FontAwesomeIcon icon={faPlus} />
            {tr("attendance:add_location")}
          </Button>
        </Col>

        <Col lg={12}>
          <TableLocations refresh={reload} />
        </Col>
      </Row>
      <ModalLocation
        show={showModal}
        handleClose={() => setShowModal(false)}
        onSuccess={() => setReload((prev) => prev + 1)}
      />
    </>
  );
};

export default TabLocations;
